//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, minLength, email } from "vuelidate/lib/validators";
import { AppMixin } from "~/node_modules/sitis-nuxt/lib/mixins"
export default {
  data() {
    return {
      form: {
        name: "",
        phone: "",
        email: "",
        text: "",
        file: null
      },
      successSend: false,
      isLoading: false,

      isPrivacyPolicy: true,
      isConsentProcessing: true,
    };
  },
  validations: {
    form: {
      name: { required, minLength: minLength(2) },
      text: { required, minLength: minLength(10) },
      email: { required, email },
      phone: { required, minLength: minLength(18) },
    },
  },
  mixins: [
    AppMixin
  ],
  computed: {
    selectedFileName: function() {
      return this.form?.file?.name || "Прикрепить документ"
    },

    messageSuccessSendForm: function () {
      return this?.vars?.["Предложение о сотрудничестве принято (попап)"] || "Спасибо за обращение! Мы обязательно ответим на ваше письмо в ближайшее время"
    }
  },

  methods: {
    onCloseFilesRewiews() {
      this.form.file = null;
    },
    async onSubmitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      } else {
        this.isLoading = true;

        let form = {
          type: "Вопросы сотрудничества",
          name: this.form.name,
          message: this.form.text,
          phone: `+${this.form.phone.replace(/\D+/g, "")}`,
          email: this.form.email,
          attachments: this.form.file
        };
        let formData = new FormData();
        Object.keys(form).map((key) => {
          formData.append(key, form[key]);
        });
        try {
          let res = await this.$api.agent.transport.post(`form/send`, formData);
          if (res) {

            this.successSend = true;

            this.isLoading = false;
          }
        } catch (error) {
          this.$modal.hide('cooperation-modal');
          console.log(error.response);

          this.isLoading = false;
        }
      }
    },

    onChangeDocument: function({ target }) {
      const { files } = target;
      const file = files?.[0] || null;

      this.form.file = file;
    }
  },
};
